import script from "./FormEditarPerfil.vue?vue&type=script&setup=true&lang=js"
export * from "./FormEditarPerfil.vue?vue&type=script&setup=true&lang=js"

import "./FormEditarPerfil.vue?vue&type=style&index=0&id=4b9eb9a8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4b9eb9a8"]])

export default __exports__